/* Enter your Custom Javascript code below without script tag */
// Company name: Developed by TechFanatic 
// Website URL: https://techfanatic.in/

$( document ).ready(function() {
  const searchElement = document.getElementsByClassName("header__icon-wrapper")
  for(let i = 0; i < searchElement.length; i++) {
    searchElement[i].onclick = function () {
      document.getElementsByClassName(".predictive-search__input").first().focus();
    }
  }

  setTimeout( function () {
    jQuery("#trustoo-widget-wrapper").insertAfter(".trustoo-reviews-widget");
  }, 1500);

  setTimeout( function () {
    jQuery('button[aria-controls="mobile-menu-1"]').attr("aria-expanded","true");
    jQuery('button[aria-controls="mobile-menu-1-1"]').attr("aria-expanded","true");
    jQuery("#th_product_bundle").insertAfter(".product-content__tabs");
    jQuery("#trustoo-widget-wrapper").insertAfter(".trustoo-reviews-widget");
  }, 1500);

  jQuery("#th_product_bundle").insertAfter(".product-content__tabs");
  jQuery("p.product-content__featured-products-title.heading.heading--small").append('<br><span style="font-size:20px;line-height: 35px;">get 10% off</span>');

  console.log("this is loading.");
  var claim_buttons = document.querySelectorAll('.salepify-fg-advanced--gifts-only .salepify-fg-advanced__claim-button');

  for (var i = 0; i < claim_buttons.length; i++) {
    console.log("Attaching event to:", claim_buttons[i]);
    claim_buttons[i].addEventListener('click', function () {
      console.log("Button clicked");
      setTimeout(function () {
        location.reload();
      }, 1000);
    });
  }

  // // Listen for Trustwill's load event (you'll need to check their documentation)
  // window.addEventListener('trustwill:loaded', function() {
  //   moveReviews();
  // });
  
  // // Fallback: Check if already loaded
  // if (window.Trustwill && window.Trustwill.loaded) {
  //   moveReviews();
  // }
  
  // function moveReviews() {
  //   const reviewsElement = document.querySelector('[data-trustwill-reviews]'); // Adjust selector
  //   const targetLocation = document.getElementById('review-content');
    
  //   if (reviewsElement && targetLocation) {
  //     targetLocation.appendChild(reviewsElement);
  //   }
  // }

  const MAX_WAIT = 10000; // Maximum time to wait (10 seconds)
  const INTERVAL = 300;   // Check every 300ms
  let elapsed = 0;
  let moved = false;

  function moveReviews() {
    if (moved) return false;

    const wrapper = document.querySelector('.trustoo-widget-wrapper, #trustoo-widget-wrapper, [class*="trustoo-widget-wrapper"]');
    const reviewsElement = wrapper || document.querySelector('[data-trustwill-reviews]');
    const targetLocation = document.getElementById('review-content');

    // Check wrapper exists AND has content (not empty)
    const hasContent = reviewsElement && (
      reviewsElement.children.length > 0 ||
      reviewsElement.innerHTML.trim() !== ''
    );

    if (hasContent && targetLocation) {
      targetLocation.appendChild(reviewsElement);
      moved = true;
      return true;
    }
    return false;
  }

  function startPolling() {
    if (moveReviews()) return;

    const interval = setInterval(function() {
      elapsed += INTERVAL;

      if (moveReviews()) {
        clearInterval(interval);
        return;
      }

      if (elapsed >= MAX_WAIT) {
        clearInterval(interval);
        console.warn('Trustoo: Widget wrapper has no content after ' + (MAX_WAIT / 1000) + 's');
      }
    }, INTERVAL);
  }

  // Run after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startPolling);
  } else {
    startPolling();
  }

  // Also hook into event if available
  window.addEventListener('trustwill:loaded', function() {
    if (!moved) moveReviews();
  });




  
  document.addEventListener('click', function (e) {
    const swatch = e.target.closest('.pcs-swatch');
    if (!swatch) return;

    const productId = swatch.dataset.productId;
    const colorName = swatch.dataset.color;
    const variantId = swatch.dataset.variantId;
    const wrapper = document.getElementById('pcs-swatches-' + productId);
    const activeName = document.getElementById('pcs-active-name-' + productId);

    if (!wrapper) return;

    // Update active swatch UI
    wrapper.querySelectorAll('.pcs-swatch').forEach(function (s) {
      s.classList.remove('pcs-swatch--active');
      s.setAttribute('aria-pressed', 'false');
    });
    swatch.classList.add('pcs-swatch--active');
    swatch.setAttribute('aria-pressed', 'true');

    // Update active color name in heading
    if (activeName) activeName.textContent = colorName;

    // ✅ Sync with Shopify's native variant selector radio inputs
    // This triggers the theme's existing product-variants logic
    if (variantId) {
      // Find the radio input for this color value and check it
      const productForm = document.querySelector('[data-js-product-form]') 
        || document.querySelector('.product-form');

      if (productForm) {
        // Find all radio inputs for color option
        const colorRadios = productForm.querySelectorAll(
          'input[type="radio"][name^="option"]'
        );

        colorRadios.forEach(function (radio) {
          if (radio.value === colorName) {
            radio.checked = true;
            // Dispatch change event so Shopify's product-variants JS picks it up
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }
    }
  });

  // Keyboard accessibility
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      const swatch = e.target.closest('.pcs-swatch');
      if (swatch) {
        e.preventDefault();
        swatch.click();
      }
    }
  });

});